<!-- 载体详情页 -->
<template>
    <div class="detailPage">
        <v-header :resultMsg="resultMsg" />
        <v-content :resultMsg="resultMsg" />
    </div>
</template>

<script>
import { CarrierInfo } from '@/api/api'
import DetailHeader from './detail/DetailHeader.vue';
import DetailContent from './detail/detailContent.vue';
export default {
    components: {
        'v-header': DetailHeader,
        'v-content': DetailContent,
    },
    data() {
        return {
            resultMsg: {}
        }
    },
    created() {
        this.detailMsg();
    },
    methods: {
        detailMsg() {
            CarrierInfo({ id: this.$route.query.id }).then(({ result, state }) => {
                if (state.code === 200) {

                    this.resultMsg = result;

                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.detailPage {
    height: 100%;
    background-color: #e5e5e5;
}
</style>
